import api from "../api/axiosInstance";

const customsService = {
  getQueue: (params) => api.get("/customs", { params }),
  markCleared: (id, notes) => api.patch(`/customs/${id}/clear`, { notes }),
  updateNotes: (id, notes) => api.patch(`/customs/${id}/notes`, { notes }),

  /**
   * Generate and download the customs declaration(s) for one or many
   * shipments. Shipments are grouped by customer server-side — each
   * customer gets their own SADEntry XML (their shipments consolidated
   * together under their own importer, never mixed with another
   * customer's). If the selection is a single customer, that's one .xml
   * file; if it spans several customers, the server bundles one .xml per
   * customer into a .zip instead (an HTTP response can only carry one
   * file). The actual filename/extension always comes from the server's
   * Content-Disposition header rather than being guessed client-side, so
   * this works for either shape.
   */
  generateAndDownload: async (shipmentIds, overrides = {}, format = "xml") => {
    const response = await api.post(
      "/customs/generate",
      { shipmentIds, overrides, format },
      { responseType: "blob" },
    );

    const disposition = response.headers?.["content-disposition"] || "";
    const filenameMatch = disposition.match(/filename="?([^"]+)"?/);
    const dateStr = new Date().toISOString().split("T")[0];
    const ext = format === "xsd" ? "xsd" : "xml";
    const filename = filenameMatch ? filenameMatch[1] : `customs_declaration_${dateStr}.${ext}`;

    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  },
};

export default customsService;
